import { NAME} from './constants';

export const selectedDetailReport = state => state[NAME].selectedDetailReport